import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "failure" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "mytitle md" }
const _hoisted_4 = { class: "failure-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "success-message-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseWrapper, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("failureTitle.value")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            innerHTML: _ctx.$t('payment3DError.value', [_ctx.ErrorMsg])
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_BaseButton, {
              onOnSubmit: _ctx.goHome,
              text: _ctx.$t('wakalahForm.value')
            }, null, 8, ["onOnSubmit", "text"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}